// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#call-history-menu-item .counter[data-v-544ba351]{font-size:.8rem;position:absolute;top:4px;left:24px;padding:3px}", ""]);
// Exports
module.exports = exports;
